// Singleton-Bus für die aktuell aktive MapLibre-Instanz.
//
// Wird von MapView beim Mount gesetzt / beim Unmount gelöscht. Non-React-
// Konsumenten (Controls) brauchen ihn nicht, die kriegen die Map via onAdd().
// Aber React-Components außerhalb von MapView (z. B. ElevationBadge in
// MapPage) können so an die Map kommen ohne ref-Drilling, und bleiben
// robust gegen Map-Rebuilds (neue Instanz → neuer set-Aufruf).

import type { Map as MLMap } from 'maplibre-gl';

type Listener = (map: MLMap | null) => void;

class MapBus {
  private current: MLMap | null = null;
  private readonly listeners = new Set<Listener>();

  get(): MLMap | null {
    return this.current;
  }

  set(map: MLMap | null): void {
    if (this.current === map) return;
    this.current = map;
    for (const l of this.listeners) l(map);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const mapBus = new MapBus();
